// Module
var code = "<div>\n  <fc-switch params=\"\n                  checked: isActive,\n                  disabled: isDisabled,\n                  label: isActiveName,\n                  uncheckedRed: true\n                \"></fc-switch>\n</div>\n";
// Exports
module.exports = code;